import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { ThemePreference } from "@sscs/types";
import { Card, Form, Page, useThemeMode } from "@sscs/ui";

const Appearance = (): React.JSX.Element => {
  const { preference, setPreference } = useThemeMode();
  const formMethods = useForm({ values: { theme: preference } });

  return (
    <Page.Root>
      <Page.Header title="Appearance" />
      <Page.Body>
        <FormProvider {...formMethods}>
          <Card.Card>
            <Card.Title
              as="h2"
              id="theme-label"
              details={["Applies immediately, saved in this browser."]}
            >
              Theme
            </Card.Title>
            <Card.Content>
              <Form.Form name="appearance-form">
                <Form.RadioGroup
                  id="theme"
                  name="theme"
                  items={[
                    {
                      id: "theme-system",
                      value: "system",
                      label: "System",
                      helperText: "Match your operating system",
                    },
                    { id: "theme-light", value: "light", label: "Light" },
                    { id: "theme-dark", value: "dark", label: "Dark" },
                  ]}
                  onChange={(event) =>
                    setPreference(event.target.value as ThemePreference)
                  }
                />
              </Form.Form>
            </Card.Content>
          </Card.Card>
        </FormProvider>
      </Page.Body>
    </Page.Root>
  );
};

export default Appearance;
